/**
 * @generated SignedSource<<69ea8514cceb03cd7a14b3a1e75ad69c>>
 * @relayHash b3379c59530f1a530a0a4079f774e80d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bc41ef8f0cfaddd3a97d66068e69b8dee15c77f71f773b37d120a0d2ad6cd1f9

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraCFOBoardPerformanceSortOrder = "ASC" | "DESC" | "%future added value";
export type JiraCFOBoardPerformanceStatus = "FAST" | "MODERATE" | "SLOW" | "%future added value";
export type JiraCFOFilterOperator = "CONTAINS" | "ENDS_WITH" | "EQUALS" | "IN" | "IS_NOT_NULL" | "IS_NULL" | "NOT_EQUALS" | "NOT_IN" | "STARTS_WITH" | "%future added value";
export type JiraCFOFilterInput = {
  boardFilter?: JiraCFOBoardFilterInput | null;
  dimensionFilter?: JiraCFODimensionFilterInput | null;
};
export type JiraCFOBoardFilterInput = {
  creatorAccountId?: ReadonlyArray<string> | null;
  keyword?: string | null;
  performanceStatus?: ReadonlyArray<JiraCFOBoardPerformanceStatus | null> | null;
  sortInput?: ReadonlyArray<JiraCFOBoardPerformanceSortInput | null> | null;
};
export type JiraCFOBoardPerformanceSortInput = {
  key?: string | null;
  order?: JiraCFOBoardPerformanceSortOrder | null;
};
export type JiraCFODimensionFilterInput = {
  name: string;
  operator: JiraCFOFilterOperator;
  values: ReadonlyArray<string>;
};
export type BoardPerformanceTabsQuery$variables = {
  after?: string | null;
  cloudId: string;
  endDate: AGG$DateTime;
  filters?: ReadonlyArray<JiraCFOFilterInput> | null;
  startDate: AGG$DateTime;
};
export type BoardPerformanceTabsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BoardPerformanceTabSummary" | "BoardPerformanceTabTable">;
};
export type BoardPerformanceTabsQuery = {
  response: BoardPerformanceTabsQuery$data;
  variables: BoardPerformanceTabsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v7 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v8 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v9 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v10 = {
  "kind": "Literal",
  "name": "dimensions",
  "value": [
    {
      "name": "jira_board_id"
    }
  ]
},
v11 = {
  "type": "PERCENTILE",
  "value": 0.5
},
v12 = {
  "type": "COUNT"
},
v13 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v14 = {
  "kind": "Literal",
  "name": "first",
  "value": 25
},
v15 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v16 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "BoardPerformanceTabsQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "BoardPerformanceTabSummary"
      },
      {
        "args": [
          (v9/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "BoardPerformanceTabTable"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BoardPerformanceTabsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "boardPerformanceSummary",
            "args": [
              (v5/*: any*/),
              (v10/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "Literal",
                "name": "metrics",
                "value": [
                  {
                    "aggregation": (v11/*: any*/),
                    "alias": "loadTime",
                    "name": "ttvc90",
                    "summarize": true
                  },
                  {
                    "aggregation": (v12/*: any*/),
                    "alias": "views",
                    "name": "*",
                    "summarize": true
                  }
                ]
              },
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "kind": "LinkedField",
                "name": "summary",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "concreteType": "JiraCFOBoardPerfStats",
                        "kind": "LinkedField",
                        "name": "boardPerfStats",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "slowBoardsCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "moderateBoardsCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fastBoardsCount"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "slowBoardThreshold"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "fastBoardThreshold"
                          }
                        ]
                      }
                    ],
                    "type": "JiraCFOBoardPerformanceMetricSummary"
                  }
                ]
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "after",
                    "value": ""
                  },
                  (v14/*: any*/)
                ],
                "concreteType": "JiraCFODataRowConnection",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  (v15/*: any*/)
                ],
                "storageKey": "data(after:\"\",first:25)"
              }
            ]
          },
          {
            "alias": "boardPerformanceTableValues",
            "args": [
              (v5/*: any*/),
              (v10/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "Literal",
                "name": "metrics",
                "value": [
                  {
                    "aggregation": (v12/*: any*/),
                    "alias": "views",
                    "name": "*"
                  },
                  {
                    "aggregation": (v11/*: any*/),
                    "alias": "loadTime",
                    "name": "ttvc90"
                  }
                ]
              },
              (v8/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "cfoAnalytics",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "args": [
                  (v9/*: any*/),
                  (v14/*: any*/)
                ],
                "concreteType": "JiraCFODataRowConnection",
                "kind": "LinkedField",
                "name": "data",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraCFODataRowEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          {
                            "concreteType": "JiraCFOMetric",
                            "kind": "LinkedField",
                            "name": "metrics",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "boardId"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "boardName"
                              },
                              {
                                "kind": "LinkedField",
                                "name": "boardCreator",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "id"
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "perfStatus"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "projectKey"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "optimizationSuggestion"
                              }
                            ],
                            "type": "JiraCFOBoardPerformanceDataRow"
                          }
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/),
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "bc41ef8f0cfaddd3a97d66068e69b8dee15c77f71f773b37d120a0d2ad6cd1f9",
    "metadata": {},
    "name": "BoardPerformanceTabsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "306a79f31bf6a2bceda3f37cbfbdfbad";

export default node;
